<template>
  <div class="crop-breed-item">
    <van-row @click="editCropBreedItem">
      <van-col span="8">
        <van-image
          :src="cropBreedItem.cropPic"
          class="crop-image"
          fit="cover"
          height="80px"
          width="80px"
        />
      </van-col>
      <van-col class="right-content" span="16">
        <div class="head wh-flex-between">
          <div>
            <span class="name">{{ cropBreedItem.cropBreed }}</span>
            <van-tag class="count" type="primary">
              {{ cropBreedItem.plantNum }} {{ cropBreedItem.cropUnit }}
            </van-tag>
          </div>
          <div class="plant-method">
            {{ cropBreedItem.plantMethod }}
          </div>
        </div>
        <div v-if="cropBreedItem.cropTypeName" class="type-name">
          <span>{{ '品种：' + cropBreedItem.cropTypeName }}</span>
        </div>
        <div class="wh-flex-between bottom">
          <van-tag class="plant-standard" size="large" type="success">
            {{ cropBreedItem.plantStandard }}
          </van-tag>
          <span class="time">{{ formatTime(cropBreedItem.plantStartDate, 'YYYY-MM-DD') }}</span>
        </div>
      </van-col>
    </van-row>
    <van-divider class="divider" />
    <div class="options">
      <van-button class="btn" plain size="small" type="info" @click="closePlant">
        <svg-icon icon-class="end" />
        {{ plantEndText }}
      </van-button>
      <van-button class="btn" plain size="small" type="info" @click="plantOption(pickIconText.text)">
        <svg-icon :icon-class="pickIconText.icon" />
        {{ pickIconText.text }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/convert/convertTime'

export default {
  name: 'CropBreedListItem',
  props: {
    cropBreedItem: {
      type: Object,
      default() {
        return {}
      }
    },
    landId: {
      type: Number,
      default: undefined
    }
  },
  computed: {

    pickIconText() {
      // 移栽
      if (this.cropBreedItem.plantMethod === '育苗') {
        return {
          icon: 'plant',
          text: '移栽'
        }
      }
      switch (this.cropBreedItem.cropType) {
        case 'agri':
        case 'forestry':
          return {
            icon: 'harvest',
            text: '采收'
          }
        case 'animal':
          return {
            icon: 'fence',
            text: '出栏'
          }
        case 'fishery':
          return {
            icon: 'catch',
            text: '捕捞'
          }
      }
      return {}
    },
    plantEndText() {
      if (this.cropBreedItem.plantMethod === '育苗') {
        return '育苗结束'
      } else {
        switch (this.cropBreedItem.cropType) {
          case 'agri':
          case 'forestry':
            return '种植结束'
          case 'animal':
          case 'fishery':
            return '养殖结束'
        }
      }
      return '结束种植'
    }
  },
  methods: {
    formatTime,
    closePlant() {
      this.cropBreedItem.plantEndText = this.plantEndText
      this.$emit('plantOption', '种植结束', this.cropBreedItem)
    },
    editCropBreedItem() {
      this.$emit('editCropBreedItem', this.cropBreedItem)
    },
    plantOption(text) {
      this.$emit('plantOption', text, this.cropBreedItem)
    }
  }
}
</script>

<style lang='less' scoped>
.crop-breed-item {
  margin: 20px 20px 0 20px;
  padding: 10px 12px 6px;
  background: #ffffff;
  border-radius: 6px;
  .divider {
    margin: 6px 0 0 0;
  }
  .right-content {
    padding-top: 10px;
    .head {
      .count {
        margin-left: 10px;
      }
      .plant-method {
        font-size: 14px;
        letter-spacing: 0.1em;
      }
    }
    .bottom {
      margin-top: 10px;
      align-items: flex-end;
      .time {
        font-size: 14px;
        color: #787878;
      }
    }
  }
  .options {
    text-align: right;
    .btn {
      border: none;
    }
  }
}
</style>
